import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row"
};
const _hoisted_2 = { class: "col-12 px-md-5 pt-3 text-center" };
const _hoisted_3 = { class: "row no-gutters text-center" };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = { class: "h2-responsive mb-5" };
const _hoisted_6 = { class: "row no-gutters" };
const _hoisted_7 = { class: "col-12 p-xl-4 p-3 bg-white border" };
const _hoisted_8 = ["href"];
const _hoisted_9 = { class: "mb-3" };
const _hoisted_10 = ["href"];
const _hoisted_11 = {
    key: 0,
    class: "col-12 my-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_google_maps_navigation_button = _resolveComponent("google-maps-navigation-button");
    return (_ctx.currentRegion)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h2", _hoisted_5, "Partnerstores in " + _toDisplayString(_ctx.currentRegion.name), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownLocations, (location, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "col-lg-4 col-md-6 p-2 text-left"
                        }, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("a", {
                                        href: _ctx.link(location),
                                        title: "Zur Store Seite",
                                        class: "VUE_StoreNameLink h5-responsive d-inline-block mr-3 mb-2"
                                    }, _toDisplayString(location.name), 9, _hoisted_8),
                                    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "font8-responsive fc-gray mb-3" }, [
                                        _createElementVNode("img", {
                                            src: "/images/store_pages/icon/icon_ankaufpartner.svg",
                                            alt: "Ankaufpartner",
                                            class: "mb-1 mr-1"
                                        }),
                                        _createTextVNode(" Offizieller "),
                                        _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
                                        _createTextVNode(" -Ankaufpartner ")
                                    ], -1)),
                                    _createElementVNode("div", null, _toDisplayString(location.street_name) + " " + _toDisplayString(location.street_number), 1),
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(location.zip_code) + " " + _toDisplayString(location.city), 1),
                                    _createElementVNode("a", {
                                        href: _ctx.link(location),
                                        title: "Zur Store Seite",
                                        class: "buttonBase buttonBlue font7-responsive mr-3"
                                    }, " Zur Storeseite ", 8, _hoisted_10),
                                    _createVNode(_component_google_maps_navigation_button, {
                                        class: "link-gray font7-responsive px-0",
                                        location: location
                                    }, null, 8, ["location"])
                                ])
                            ])
                        ]));
                    }), 128)),
                    (_ctx.locations.length > 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("button", {
                                class: "buttonBase buttonGreen",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.toggleCards && _ctx.toggleCards(...args)))
                            }, _toDisplayString(_ctx.buttonText), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
